<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Admin',
};
</script>
